// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__gG11W","inner":"Footer_inner__2-JWN"};